import { render, staticRenderFns } from "./paymentStatus.vue?vue&type=template&id=789c899d&scoped=true&"
import script from "./paymentStatus.vue?vue&type=script&lang=js&"
export * from "./paymentStatus.vue?vue&type=script&lang=js&"
import style0 from "./paymentStatus.vue?vue&type=style&index=0&id=789c899d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c899d",
  null
  
)

export default component.exports